export default __webpack_public_path__ + "static/media/star.9b64ab61.png";